import { render, staticRenderFns } from "./VFormItemLocation.vue?vue&type=template&id=63803e62&"
import script from "./VFormItemLocation.vue?vue&type=script&lang=js&"
export * from "./VFormItemLocation.vue?vue&type=script&lang=js&"
import style0 from "./VFormItemLocation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63803e62')) {
      api.createRecord('63803e62', component.options)
    } else {
      api.reload('63803e62', component.options)
    }
    module.hot.accept("./VFormItemLocation.vue?vue&type=template&id=63803e62&", function () {
      api.rerender('63803e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemLocation.vue"
export default component.exports